import { ITicketAttachment } from "../../models/Tickets/Ticket";

interface TicketImagePreviewModalProps {
  attachment: ITicketAttachment | null;
  src?: string;
  onClose: () => void;
  onDownload: (attachment: ITicketAttachment) => void;
}

/** Full-size view of an image attachment, opened from the chat or the attachments list. */
export default function TicketImagePreviewModal({
  attachment,
  src,
  onClose,
  onDownload,
}: TicketImagePreviewModalProps) {
  if (!attachment || !src) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
      onClick={onClose}
    >
      <div
        className="max-h-[90vh] max-w-[90vw] overflow-auto rounded bg-white p-3"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-2 flex items-center justify-between gap-3">
          <p className="text-sm font-medium text-slate-800">
            {attachment.fileName}
          </p>
          <button
            type="button"
            className="rounded border border-slate-300 px-2 py-1 text-xs text-slate-700"
            onClick={onClose}
          >
            Close
          </button>
        </div>
        <img
          src={src}
          alt={attachment.fileName}
          className="max-h-[75vh] max-w-[85vw] object-contain"
        />
        <div className="mt-3">
          <button
            type="button"
            onClick={() => onDownload(attachment)}
            className="text-xs font-medium text-orange-700 hover:text-orange-900"
          >
            Download image
          </button>
        </div>
      </div>
    </div>
  );
}
